/**
 * Valid values for the public sharing state of publicly shareable items.
 */
export var PublicSharingState;
(function (PublicSharingState) {
    PublicSharingState["MARKED_FOR_SHARING"] = "marked_for_sharing";
    PublicSharingState["MARKED_FOR_UNSHARING"] = "marked_for_unsharing";
    PublicSharingState["NOT_SHARED"] = "not_shared";
    PublicSharingState["SHARED"] = "shared";
    PublicSharingState["APPROVED_FOR_UNSHARING"] = "approved_for_unsharing";
    PublicSharingState["APPROVED_FOR_SHARING"] = "approved_for_sharing";
})(PublicSharingState || (PublicSharingState = {}));
